<template>
  <div class="header-wrap">
    <div class="content">
      <img
          height="45"
          src="https://static.rhkj.com/renhe_fe/other/logo4-1.png"/>
      <img
          height="40"
          style="margin-left: 20px;"
          src="https://static.rhkj.com/renhe_fe/other/logo4-2.png"/>
      <div class="grow"></div>

      <div class="link"
           :class="{'active': route.name == 'PostMatch'}"
           @click="goPage('PostMatch')">岗位
      </div>
      <div
          :class="{'active': route.name == 'MyResumeView' || route.name == 'MyResumeEdit'}"
          class="link" @click="goPage('MyResumeView')">我的简历
      </div>
      <div
          :class="{'active': route.name == 'MsgCenter'}"
          class="link" @click="goPage('MsgCenter')">消息通知
      </div>


      <el-dropdown trigger="hover" @command="command" popper-class="user-down-center">
        <div class="user-info">
          <img
              width="40"
              height="40"
              src="https://static.rhkj.com/front/web/v3/img/default/default-woman-avatar.png"
          />
          <span class="user-name">{{ store?.userInfo.name }}</span>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <!--            <el-dropdown-item divided class="down-menu-item">
                          <a :href="`${baseHost}/web/uc/myInfo`" class="down-link">
                            个人资料
                          </a>
                        </el-dropdown-item>-->
            <el-dropdown-item command="logOut" class="down-menu-item">
              <div>
                退出登录
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>

      </el-dropdown>
    </div>
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import {quitLogin} from "@/api/login";
import useUserStore from "@/store/modules/user";

const store = useUserStore()

const router = useRouter()
const route = useRoute()

function goPage(name) {
  router.replace({
    name,
  })
}

function command(arg) {
  if (arg == 'logOut') {
    quit()
  }
}

async function quit() {
  try {
    await quitLogin()
  } catch (e) {
  } finally {
    await useUserStore().logOut()
    router.replace({
      path: '/login',
      replace: true
    })
  }
}
</script>


<style scoped lang="scss">
.header-wrap {
  height: 80px;
  background-color: #333333;

  .content {
    width: 1200px;
    margin: auto;
    height: 100%;
    display: flex;
    align-items: center;

    .grow {
      flex-grow: 1;
    }

    .link {
      color: rgba(255, 255, 255, 0.5);
      font-size: 16px;
      margin-right: 40px;
      cursor: pointer;

      &.active {
        color: rgba(255, 255, 255, 1);
      }
    }

    .user-info {
      display: flex;
      align-items: center;
      cursor: pointer;
      outline: none;

      .user-name {
        color: #FFFFFF;
        font-size: 18px;
        margin-left: 10px;
        line-height: 25px;
      }
    }
  }
}
</style>
